export default "/50f517735fec46580f19aae3e56e9fe21614ea75/c149c2995e67c98d8198109bf15793c7.svg";